import { PayloadAction } from '@reduxjs/toolkit';
import { ChannelSettingsReducerCreator } from '../types';

const setShowStripeModalReducer = (create: ChannelSettingsReducerCreator) => {
  return create.reducer((state, action: PayloadAction<boolean>) => {
    state.showStripeModal = action.payload;
  });
};

export default setShowStripeModalReducer;
